<div class="container my-2">
  <div class="row easie-form">
    <div class="col-12 mx-auto">
      <p class="easie-form-label mb-0">Department</p>
      <div class="input-group" *ngIf="canUpdate">
        <!-- <ion-select
          [multiple]="true"
          [disabled]="!canUpdate"
          interface="modal"
          placeholder="Select Deparment"
          [(ngModel)]="pageSpecificFormObject.departmentIds"
          [value]="pageSpecificFormObject.departmentIds"
        >
          @for (department of departmentList; track department; let j = $index) {
            <ion-select-option value="{{ department.id }}">{{ department.name }}</ion-select-option>
          }
        </ion-select> -->

        <ion-select [(ngModel)]="pageSpecificFormObject.departmentIds"  multiple="true" interface="popover" class="form-control-selectbox" 
          name="pageSpecificFormObject.department" placeholder="Select" [disabled]="!canUpdate">
          <ion-select-option *ngFor="let level of departmentList" value="{{level.id}}">
            {{level.name}}
          </ion-select-option>
        </ion-select>
      </div>
    </div>
    <div class="col-12 mx-auto separator-light select-pills"  *ngIf="!canUpdate">
      <div class="row pt-1">
        <div class="col-1"></div>
        <div class="col-11">
          <div class="mb-1">
            <div *ngFor="let department of departmentList">
              <div *ngIf="pageSpecificFormObject.departmentIds && pageSpecificFormObject.departmentIds.includes('' + department.id)"
                  class="d-flex flex-row  align-items-center">
                <i class="fas fa-minus fa-xs"></i> &nbsp; <p class="font-weight-light mb-0">{{department.name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
